import { THIRD_PARTY_LINKS_BASE_URL } from '@/config/env';
import { useOpenExternalLink } from '@/hooks/useOpenExternalLink';
import type { VideoMeeting } from '@/types/video';

interface Params {
  meetings: VideoMeeting[];
  onError: () => void;
}

export const useJoinVideoMeeting = ({ meetings, onError }: Params) => {
  const openExternalLink = useOpenExternalLink(onError);

  return async (id: string) => {
    const meeting = meetings.find((item) => item.id === id);

    if (!meeting?.url) {
      onError();
      return;
    }

    const { url, isSingleSignOn } = meeting;

    await openExternalLink({
      url: isSingleSignOn ? `${THIRD_PARTY_LINKS_BASE_URL}${url}` : url,
      isSingleSignOn,
    });
  };
};
